export enum PaymentMethod {
  CreditCard = 'credit-card',
  Financing = 'financing',
  MonthlyRental = 'monthly-rental',
  PersonalCheck = 'personal-check',
  RentToOwn = 'rent-to-own',
}
